import React, { Component } from 'react';

import { USER_ROLE_ADMIN } from 'common/userRoles';
import {
  DATA_TABLE_SOURCE_SUNSETUP_LISTING_ORDERS,
  DATA_TABLE_VIEW_ID_SUNSETUP_LISTING_ORDERS,
} from 'common/dataTableConstants';

import PartnerActions from 'client/actions/Partner';
import ListingActions from 'client/actions/Listing';

import branch from 'client/core/branch';

import { SCREEN_ID_ADMIN_LISTING_ORDERS } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withScreenId from 'client/helpers/withScreenId';
import allowedRoles from 'client/helpers/allowedRoles';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrCard from 'client/components/SrCard/SrCard';
import SrText from 'client/components/SrText';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrSunSetupListingOrder from 'client/components/SrSunSetupListingOrder/SrSunSetupListingOrder';
import SrPartnerList from 'client/components/SrPartnerList';
import SrSunSetupOrderDetails from 'client/components/SrSunSetupOrderDetails/SrSunSetupOrderDetails';
import SrButton, {
  SR_BUTTON_FONT_SIZE_SMALL,
  SR_BUTTON_HEIGHT_SHORTER,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';
import SrAdminNotes, {
  ADMIN_NOTES_VARIATION_LISTING_JOB_ORDER_NOTES,
} from 'client/components/SrAdminNotes';

function getDataTableSettingsFromProps({ listingId }) {
  const dataTableSettings = {
    dataSource: DATA_TABLE_SOURCE_SUNSETUP_LISTING_ORDERS,
    rootViewId: DATA_TABLE_VIEW_ID_SUNSETUP_LISTING_ORDERS,
    initialViewSettings: {
      sort: {
        promiseDate: 'asc',
      },
      filter: {
        id: listingId,
      },
      loadAllData: true,
    },
    itemsPropName: 'listings',
    count: 1,
  };

  return dataTableSettings;
}

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_LISTING_ORDERS)
@withScrollToTop
@branch(() => {
  return {
    listing: ['listing'],
    currentUser: ['currentUser'],
  };
})
@branch(({ listing }) => {
  if (!listing?.partnerId) {
    return {};
  }
  return { partner: ['partners', 'byId', listing.partnerId] };
})
class ListingJobOrdersPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Listing Orders',
    section: 'Admin',
  });

  static fetchData(match, inject) {
    const listingId = parseInt(match.params.listingId, 10);
    if (listingId) {
      return ListingActions.getById(inject, listingId).then((listing) => {
        if (listing.partnerId) {
          return PartnerActions.getById(inject, {
            partnerId: listing.partnerId,
          });
        }
      });
    }
  }

  render() {
    const { match, history, partner, currentUser } = this.props;
    const listingId = parseInt(match.params.listingId, 10);
    const backUrl = history.location.pathname;
    const sunsetupUrl = `/sunsetup/orders/create?backUrl=${backUrl}&listingId=${listingId}`;
    return (
      <SrPartnerPageV2
        navbarTitle="Listing Orders"
        backUrl="/sunsetup/orders"
        redirectToLastLocation
        navBarActionButton={
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_GREEN}
            heightType={SR_BUTTON_HEIGHT_SHORTER}
            fontSizeType={SR_BUTTON_FONT_SIZE_SMALL}
            onClick={() => history.push(sunsetupUrl)}
          >
            Create Order
          </SrButton>
        }
      >
        <SrDataTableConnected {...getDataTableSettingsFromProps({ listingId })}>
          {({ listings, reloadItems }) => {
            if (!listings[0]) {
              return null;
            }
            const { sunlock, jobOrders, ...listing } = listings[0];
            return (
              <>
                <SrSunSetupOrderDetails
                  listing={listing}
                  partnerDisplayName={partner?.displayName}
                  partnerLogo={partner?.logoUrl}
                  sunlock={sunlock}
                />
                <SrCard maxHeight="200px" overflow="auto">
                  <SrText
                    font="greycliff"
                    fontSize="20px"
                    weight="800"
                    color="blueGreycliff"
                    display="block"
                    paddingBottom="20px"
                  >
                    Job Order Notes
                  </SrText>
                  <SrAdminNotes
                    variation={ADMIN_NOTES_VARIATION_LISTING_JOB_ORDER_NOTES}
                    listingId={listingId}
                    currentUser={currentUser}
                  />
                </SrCard>
                <SrPartnerList twoColumns>
                  {(jobOrders || []).map((jobOrder) => (
                    <SrSunSetupListingOrder
                      key={jobOrder.id}
                      listing={listing}
                      jobOrder={jobOrder}
                      currentUser={currentUser}
                      reloadItems={() =>
                        reloadItems({
                          count: 1,
                          filter: {
                            id: listingId,
                          },
                        })
                      }
                    />
                  ))}
                </SrPartnerList>
              </>
            );
          }}
        </SrDataTableConnected>
      </SrPartnerPageV2>
    );
  }
}

ListingJobOrdersPage.displayName = 'ListingJobOrdersPage';

export default ListingJobOrdersPage;
